<template>
  <!-- ユーザーメッセージ（アバターは吹き出し右上＝行の上端揃え） -->
  <div
    v-if="message.isUser"
    class="flex items-start justify-end gap-3 mb-6"
  >
    <div class="flex flex-col items-end max-w-[85%] min-w-0" style="max-width: 640px">
      <div
        class="px-5 py-4 rounded-2xl shadow-md bg-[#37acdb] text-white"
        style="border-radius: 18px; box-shadow: 0 2px 8px rgba(55, 172, 219, 0.25)"
      >
        <p class="text-[15px] leading-[1.8] break-words">{{ message.content }}</p>
      </div>
      <span class="text-[11px] text-gray-400 mt-1.5">{{ formattedTime }}</span>
    </div>
    <div
      class="w-10 h-10 rounded-full flex-shrink-0 overflow-hidden bg-gray-100 flex items-center justify-center mt-0.5"
    >
      <img
        v-if="userAvatarUrl"
        :src="userAvatarUrl"
        alt="User"
        class="w-full h-full object-cover"
      />
      <svg
        v-else
        class="w-5 h-5 text-gray-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    </div>
  </div>

  <!-- AIメッセージ（枠なし・ChatGPT風） -->
  <div v-else class="flex items-start gap-3 mb-6 group">
    <div
      class="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden bg-white shadow-sm flex items-center justify-center border border-gray-100 mt-0.5"
    >
      <img
        :src="aiIconUrl"
        alt="AI"
        class="w-full h-full object-cover"
      />
    </div>
    <div class="flex-1 min-w-0 max-w-[720px]">
      <AIMessageContent
        :content="message.content"
        :is-streaming="message.isStreaming"
        :parsed-html="message.parsedHtml"
      />
      <div class="mt-1.5">
        <span class="text-[11px] text-gray-400">{{ formattedTime }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import AIMessageContent from './AIMessageContent.vue';

const props = defineProps({
  message: {
    type: Object,
    required: true,
    default: () => ({
      content: '',
      isUser: false,
      timestamp: null,
      isStreaming: false,
      parsedHtml: null,
    }),
  },
  userAvatarUrl: {
    type: String,
    default: null,
  },
  aiIconUrl: {
    type: String,
    default: '/img/common/ai_img.svg',
  },
});


const formattedTime = computed(() => {
  const ts = props.message.timestamp;
  if (!ts) return '';
  const d = ts instanceof Date ? ts : new Date(ts);
  return d.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' });
});
</script>
